import Loadable from '../../components/loadable';

const ContactTasks = Loadable({
  loader: () => import('../../pages/contacts/tasks'),
  type: 'block',
});

angular.module('gym').value('ContactTasks', ContactTasks);

const ContactTasksFiltersModal = Loadable({
  loader: () => import('../../pages/contacts/tasks/contact_tasks_filters_modal'),
  type: 'modal',
});

angular.module('gym').value('ContactTasksFiltersModal', ContactTasksFiltersModal);
